export default __webpack_public_path__ + "static/media/termsofuse.b616c762.svg";